import React from 'react';
import services from '../../../services'
import EntityDetailPopUp from './EntityDetailPopUp';


class BoletimRightTabLI extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            entity_row: {},
            res: {},
            popUpDetail:''
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        console.log("mount in LI worked")
        console.log("props areeeeeee.... ", this.props.nif, typeof this.props.nif)
        this.getEntityList()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.date !== this.props.date) {
            console.log("update in LI worked")
            this.getEntityList()
        }
    }

    getEntityDetail = async (id) => {
        try {
            let Request = {};
            Request.entityId = parseInt(id);
            let link = "/Revenue/GetEntityDetail";
            let res = await services.apiCall.requestApi(link, Request);
            //console.log("hello hi some thing");
            //console.log(res);
            if (res) {
                console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> API HIT >>>>>>>>>>>>>>>>>>>>>", res)
                this.setState({
                    res: res.busEntidade
                    }
                );
            this.popUpDetail()
            }

        } catch (error) {
            this.setState({error})
        }
    }

    popUpDetail = () => {
        let popUpDetail = (
            <EntityDetailPopUp response={this.state.res} closePopup ={() => this.props.closePopup()}/>
        )
        this.setState({
            popUpDetail
        })
    }
    //this.state.entity_row[this.props.nif].codEntidade

    //http://ivdp.ambisig.com/api/api/Revenue/getEntityDetail
        getEntityList = async () => {
            // this.setState({
            //     entity_row: {}
            // })
            services.EntityList.getEntityList('parcel', null, this.props.nif.toString())
            .then(res => {
                console.log(">>>>>>>>>>>>>>>>>>>>> response is >>>>>>>>>>>>>>",res)
                this.setState({
                    entity_row: res.entity_row
                })
            })
            .catch(error => {
                console.log("error is...", error)
            })
            
        }

    
//onClick={() => this.getEntityDetail(this.state.entity_row[this.props.nif].codEntidade)}
    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            Object.keys(this.state.entity_row).length > 0 &&
            <div>
                <div className="d-flex justify-content-between">
                    { 
                        this.props.tab === 'boletimProprietario' ? 
                        <div className="info-data flex-grow-4">
                            <div className="mb-2">
                                <p className="m-0">{this.state.entity_row && this.state.entity_row[this.props.nif] && this.state.entity_row[this.props.nif].nome}</p>
                            </div>
                            <div>
                                <div className="d-md-flex">
                                    {this.state.entity_row && this.state.entity_row[this.props.nif] && this.state.entity_row[this.props.nif].nifap}
                                    {/* {
                                        Object.keys(this.state.entity_row).includes(window.localStorage.getItem('nif')) &&
                                        <p className="ml-2 titular-tag">Proprietário</p>
                                    } */}
                                    <p className="ml-2 titular-tag">Proprietário</p>
                                </div>

                            </div>
                        </div>
                    :
                    
                        <div className="info-data flex-grow-4">
                            <div className="mb-2">
                                <p className="m-0">{this.state.entity_row && this.state.entity_row[this.props.nif] && this.state.entity_row[this.props.nif].nome}</p>
                            </div>
                            <div>
                                <div className="d-md-flex">
                                {this.state.entity_row && this.state.entity_row[this.props.nif] && this.state.entity_row[this.props.nif].nifap}
                                {/* {
                                    Object.keys(this.state.entity_row).includes(window.localStorage.getItem('nif')) &&
                                } */}
                                    <p className="ml-2 titular-tag">Explorador</p>
                                </div>
                            </div>
                        </div>
                    }

                    
                
                    <div className="icons-display">
                        {/* <i className="fa fa-bookmark fa-2x" aria-hidden="true"></i> */}
                        <i data-toggle="modal" data-target='#left-entity-popup-detail' className="ml-2 fa fa-info-circle font-18 cursor-pointer" aria-hidden="true" onClick={() => this.getEntityDetail(this.state.entity_row[this.props.nif].codEntidade)}></i>
                    </div>
                    
                    {/* <Tooltip title="Detalhes da entidade" color={"#333"}>
                    <span className="cursor-pointer"><i className="fas fa-exclamation-circle ml-1" onClick={() => this.props.detailClick(this.state.entity_row && this.state.entity_row[this.props.nif])} data-toggle="modal" data-target='#left-detail-popup'></i></span>
                    </Tooltip> */}
                </div>
                <hr/>
                <div className="modal left-popup" id="left-entity-popup-detail">
                    <div className="modal-dialog modal-sm">
                        {
                            this.state.popUpDetail
                        }
                    </div>
                </div>
            </div>
        )
    }
}


export default BoletimRightTabLI;